import merge from 'lodash.merge'

import commonsFr from './fr.json'
import textConditionFr from './textCondition/fr.json'

export const filtersFr = merge({}, commonsFr, textConditionFr)
